import Modal from '@components/App/Modal/Modal'
import NotificationWrapper from '@components/App/NotificationContainer/NotificationWrapper'
import SystemDialogs from '@components/App/SystemDialogs'
import { DashboardLayout, TemplatesContent } from '@components/Dashboard'
import type React from 'react'

import { AuthenticatedWrapper } from './AuthenticatedWrapper'

export const DashboardTemplates: React.FC = () => (
  <AuthenticatedWrapper>
    <NotificationWrapper />
    <DashboardLayout>
      <TemplatesContent />
    </DashboardLayout>
    <SystemDialogs />
    <Modal />
  </AuthenticatedWrapper>
)
